import { YStack, XStack, Text } from 'tamagui'
import type { ChecklistSlide as ChecklistSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor, parseLinkedText } from './shared'

export function ChecklistSlide({ slide }: { slide: ChecklistSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner style={{ padding: 'clamp(32px, 6vw, 80px)' }}>
        <Text
          fontFamily="$heading"
          fontWeight="700"
          color={accentColor}
          style={{ fontSize: 'clamp(24px, 3.5vw, 44px)', lineHeight: '1.2em' }}
        >
          {slide.headline}
        </Text>
        {slide.instruction && (
          <Text
            fontFamily="$mono"
            color="$textMuted"
            fontStyle="italic"
            style={{ fontSize: 'clamp(11px, 1.2vw, 16px)' }}
          >
            {slide.instruction}
          </Text>
        )}
        <YStack gap="$5" marginTop="$4">
          {slide.items.map((item, i) => (
            <XStack key={i} gap="$4" alignItems="center">
              <Text
                fontFamily="$mono"
                color={item.checked ? '#22C55E' : '$textMuted'}
                style={{ fontSize: 'clamp(18px, 2vw, 28px)' }}
              >
                {item.checked ? '☑' : '☐'}
              </Text>
              <Text
                fontFamily="$body"
                color={item.checked ? '$textMuted' : '$textSecondary'}
                flex={1}
                style={{
                  fontSize: 'clamp(14px, 1.8vw, 22px)',
                  lineHeight: '1.4em',
                  textDecoration: item.checked ? 'line-through' : 'none',
                }}
              >
                {parseLinkedText(item.text)}
              </Text>
            </XStack>
          ))}
        </YStack>
      </SlideInner>
    </SlideContainer>
  )
}
